import { Component } from '@angular/core';

@Component({
  selector: 'app-home-large-accounts',
  templateUrl: './home-large-accounts.component.html'
})
export class HomeLargeAccountsComponent {
}
